module.exports = __webpack_public_path__ + "static/media/Brochure-Motores-Rebobinables-01.7883e80a.png";